import "../../styles/Modal.css"

import ManagerAddForm from "../forms/ManagerAddForm"

function ManagerModal({ onClose }) {

  return (
    <div className="m-overlay" >

      <div className="sm-content" >
        <div className="m-header" >
          <h4 className="m-title">Add Manager</h4>
          <button className="m-cancel-button-x" onClick={onClose}>X</button>
        </div>

        <div className="ma-body" >
          <ManagerAddForm />
        </div>

        <div className="sm-footer" >
          <button className="m-cancel-button" onClick={onClose}>Close</button>
        </div>
      </div>

    </div>
  )
}

export default ManagerModal
